import { SimpleImageField, SimpleTextInput, SimpleToggleField } from './fields';
import ISimpleField from './ISimpleField.interface';
import React from 'react';
const MakeField = (
    field: ISimpleField,
    idx: number,
    hook: {
        values: {};
        handleChange: Function;
        errors: Record<string, any>;
    },
) => {
    switch (field.type) {
        case 'text':
            return <SimpleTextInput hook={hook} key={idx} label={field.label || ''} name={field.name} />;
        case 'toggle':
            return (
                <SimpleToggleField
                    additionalFields={field.fieldSpecific}
                    hook={hook}
                    key={idx}
                    label={field.label || ''}
                    name={field.name}
                />
            );

        case 'image':
            return (
                <SimpleImageField
                    key={idx}
                    label={field.label || ''}
                    name={field.name}
                    {...field.fieldSpecific}
                    hook={hook}
                />
            );

        default:
            return <SimpleTextInput hook={hook} key={idx} label={field.label || ''} name={field.name} />;
    }
};

export default MakeField;
